module.exports = __webpack_public_path__ + "img/illustration-forgot-password-dark.45fbe14b.png";